'use client';

import React from 'react';
import Image from 'next/image';
import './MarketProduct.css';

const MarketProducts = () => {
  const products = [
    {
      id: 1,
      title: 'Photo Frame',
      image: '/assets/images/photoframe_custom.jpg',
    },
    {
      id: 2,
      title: 'Calendar',
      image: '/assets/images/calander_custom.png',
    },
    {
      id: 3,
      title: 'Flyers',
      image: '/assets/images/flyers_custom.png',
    },
    {
      id: 4,
      title: 'Business Cards',
      image: '/assets/images/visitingcard_custom.png',
    }
  ];

  return (
    <section className="market-products-section" id="trending">
      <div className="market-products-container">
        <div className="market-products-header">
          <h2 className="market-products-title">Products that are trending in the market</h2>
          <p className="market-products-subtitle">
            Our technology helps make your products unique, market-trending, and ready to take your business to the next stage.
          </p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-visual">
                <div className="stripe-background"></div>
                <div className="product-image-wrapper">
                   {/* Placeholder div if image fails or for demonstration */}
                   <div className="image-placeholder">
                      <Image 
                        src={product.image} 
                        alt={product.title} 
                        width={200} 
                        height={250} 
                        objectFit="contain"
                      />
                   </div>
                </div>
                <div className="pedestal">
                  <div className="pedestal-top"></div>
                  <div className="pedestal-base"></div>
                </div>
              </div>
              <h3 className="product-title">{product.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketProducts;
